import './Notifications.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import Notification from './Notification';

const NotificationsComponent = ({ notifications, removeNotification }) => {
  if (!notifications.length) {
    return null;
  }

  return createPortal(
    <div className="notifications-wrapper">
      {notifications.map((config) => (
        <Notification
          key={config.id}
          {...{
            config,
            removeNotification,
          }}
        />
      ))}
    </div>,
    document.getElementById('notifications')
  );
};

NotificationsComponent.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      message: PropTypes.object.isRequired,
      values: PropTypes.object,
    })
  ).isRequired,
  removeNotification: PropTypes.func.isRequired,
};

export default NotificationsComponent;
